export const CHECKOUTS = [
	{
		id: "4bb518fd-d3c8-4c63-ba2b-4794484bbb7b",
		name: "Caja 1",
	},
];
